import React, { useState,useEffect } from 'react'
import Login from './Login'
import CrifPageMain from './CRIF/CrifPageMain'
import Loader from './common/Loader'
export default function MainPage() {
  const [loader, setLoader] = useState(false)
  const [pageView, setPageView] = useState("login")

  const PageHandler=(type)=>{
    setPageView(type)
  }

  useEffect(()=>{
    setLoader(true)
    const login = window.sessionStorage.getItem("AdminLogin")
    const ParsedData = JSON.parse(login)
    if(ParsedData?.email != "" && ParsedData?.email != null && ParsedData?.email != undefined && ParsedData?.password != "" && ParsedData?.password != null && ParsedData?.password != undefined){
      setPageView("crifPage")
    }else{
      setPageView("login")
    }
    setLoader(false)
  },[])

  return (
    <>
    {
      loader ?
      <Loader />
    :''}
      {
        pageView === "login" ?
          <Login PageHandler={PageHandler}/>
          : ''}
      {
        pageView === "crifPage" ?
          <CrifPageMain PageHandler={PageHandler}/>
          : ''}
    </>
  )
}
